export default __webpack_public_path__ + "static/media/Ballroll_00238.5617ca5f.png";